<template>
  <el-dialog
    title="Payment Review"
    :visible.sync="dialogVisible"
    size="large"
    id="check-printer-dialog"
    :style="`${ active === 1 ? 'z-index: 11000 !important' : ''}`"
    top="5%"
    @close="resetFields"
    :show-close="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <el-row type="flex" align="middle" justify="between" style="padding: 0 20px; margin-bottom: 12px;">
      <el-col :span="12">
        <el-row type="flex" align="middle" justify="start" style="padding: 10px 0;">
          <el-steps :space="200" :active="active" finish-status="success" :center="true">
            <el-step title="Review" description="transactions" />
            <!-- <el-step title="Print" description="payments" /> -->
            <el-step title="Summarize" description="payment run" />
          </el-steps>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="end" align="middle" style="padding: 20px 0 0 0;">
          <!-- <div
            v-if="active === 1"
            style="padding: 0 12px;">
            Did these payments print correctly?
          </div>
          <el-button
            v-if="active === 1"
            plain
            :disabled="buildProgress !== 100"
            @click="reprintChecks">
            No
          </el-button> -->
          <el-button
            v-if="active === 0 && !printErrors"
            plain
            @click="closeCheckPrinter">
            Cancel
          </el-button>
          <el-button
            v-if="active === 0 && !printErrors"
            type="success"
            @click="goToNextStep">
            Process
          </el-button>
          <el-button
            v-if="active === 0 && printErrors"
            type="danger"
            @click="skipToLastStep"
            :disabled="!!enableReprintBtn">
            All payments printed
          </el-button>
          <el-button v-else-if="active === 1" type="danger" plain @click="printCopyMethod" :disabled="isNotPrintable" :loading="!!loadingRelated">
            {{ !!loadingRelated ? 'Loading' : 'Print Copy' }}
          </el-button>
          <el-button
            v-if="active === 1"
            type="plain"
            :loading="processingReport"
            @click="generateCheckRegisterReport">
            {{ processingReport ? 'Working' : 'Payment Register Report' }}
          </el-button>
          <el-button
            v-if="active === 0 && printErrors"
            type="success"
            @click="goToNextStep"
            :disabled="!enableReprintBtn">
            Reprint
          </el-button>
          <!-- <el-button
            v-else-if="active === 1"
            type="success"
            :disabled="buildProgress !== 100"
            @click="goToNextStep">
            Yes
          </el-button> -->
          <el-button
            v-else-if="active === 1"
            type="success"
            @click="closeCheckPrinter">
            Done
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <div style="padding: 0 20px;">
      <el-carousel
        arrow="never"
        :initial-index="0"
        :autoplay="false"
        :height="`${checkPdfHeight + 50}px`"
        ref="checkCarousel"
        indicator-position="none">
        <el-carousel-item style="overflow-y: scroll;">
          <el-row>
            <el-col>
              <el-row type="flex" style="margin-top: 12px;">
                <h4 style="font-weight: bold; margin: 0;">{{getBankById(selectedBank).name}}</h4>
              </el-row>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" justify="start" class="headerRow" v-if="paymentType === 'EFT'">
            <el-col :span="4">
              First available payment number:
            </el-col>
          </el-row>
          <el-row v-if="paymentType === 'EFT'" style="margin-bottom: 10px;">
            <el-col :span="3">
              <el-input
                :name="`payment_number_start`"
                size="small"
                placeholder="Payment number"
                v-model="startingPaymentConfNumber"
                @change="updatePaymentConfNumbersOnStep2">
              </el-input>
            </el-col>
          </el-row>
          <h3 v-if="!printErrors" style="font-weight: 100;">Review Payments</h3>
          <h3 v-else style="font-weight: 300; color: darkred">
            Please select payments that did not print correctly
          </h3>
          <el-row type="flex" justify="center">
            <el-form ref="checkForm">
              <table id="check-review-form">
                  <tr>
                    <th class="cell-gray">Payment #<span style="color: red;"> *</span></th>
                    <th class="cell-gray">Amount</th>
                    <th class="cell-gray">Payee</th>
                    <th class="cell-gray">Company</th>
                    <th class="cell-gray" v-if="checkDateRange">
                      Date{{ allowableDateRangeString ? ` (${allowableDateRangeString})` : '' }}<span style="color: red;"> *</span>
                    </th>
                    <th class="cell-gray">Memo<span style="color: red;"> *</span></th>
                    <th class="cell-gray" v-if="!printErrors">Period</th>
                    <th class="cell-gray" v-if="printErrors">Process error</th>
                  </tr>
                  <tr v-if="!printErrors" v-for="(c, i) in preview" :key="`a${c.check}`">
                    <td>
                      <el-input
                        :name="`${c.check}__number`"
                        v-model="preview[i].form['payment_confirmation_number']"
                        @change="updateGroupedCheckPreviews(preview[i])"
                        class="keynav"
                      />
                    </td>
                    <td>
                      <MoneyField
                        style="text-align: left;"
                        :name="`${c.check}__amount_decimal`"
                        v-model="preview[i].form['amount_decimal']"
                        :disabled="true"
                        class="keynav check-amt-field"
                      />
                    </td>
                    <td>
                      <el-input
                        :name="`${c.check}__payee`"
                        v-model="preview[i].form.payee_name"
                        disabled
                        class="keynav"
                      />
                    </td>
                    <td>
                      <el-input
                        :name="`${c.check}__company`"
                        v-model="preview[i].form.company.label"
                        disabled
                        class="keynav"
                      />
                    </td>
                    <td v-if="checkDateRange">
                      <DateField
                        :customStyle="{ width: '100%' }"
                        :name="`${c.check}__date`"
                        :allowableRange="{
                          start: checkDateRange.start,
                          end: checkDateRange.end,
                          errMsg: `Check date must be between ${allowableDateRangeString}`}"
                        v-model="preview[i].form.date"
                        class="keynav"
                      />
                    </td>
                    <td>
                      <el-input
                        :name="`${c.check}__description`"
                        v-model="preview[i].form.description"
                        class="keynav"
                      />
                    </td>
                    <td>
                      <el-select :name="`${c.check}__period`" v-model="preview[i].form.period" class="keynav" style="width: 100%;">
                        <el-option
                          v-for="(option, key) in periodOptions"
                          :key="key"
                          :label="option.label"
                          :value="option.value"
                        />
                      </el-select>
                    </td>
                  </tr>
                  <tr v-if="printErrors" v-for="(v, i) in checks" :key="v.id">
                    <td style="padding: 6px 12px;">
                      <div>{{ v.number }}</div>
                    </td>
                    <td class="cell-padded">
                      <div>{{ v.amount_decimal }}</div>
                    </td>
                    <td class="cell-padded">
                      <div>{{ getVendorById(v.vendor).name }}</div>
                    </td>
                    <td class="cell-padded">
                      <div>{{ getCompanyByBatchId(v.batch).name }}</div>
                    </td>
                    <td v-if="checkDateRange">
                      <DateField
                        :customStyle="{ width: '100%' }"
                        :name="`${v.check}__date`"
                        :allowableRange="{
                          start: checkDateRange.start,
                          end: checkDateRange.end,
                          errMsg: `Check date must be between ${allowableDateRangeString}`}"
                        :disabled="true"
                        v-model="checks[i].form.date"
                        class="keynav"
                      />
                    </td>
                    <td class="cell-padded">
                      <div>{{ v.description }}</div>
                    </td>
                    <td class="cell-padded">
                      <div style="text-align: center;">
                        <input
                          type="checkbox"
                          :name="`${v.id}__printerr`"
                          v-model="checks[i].printErr"
                          @change="handlePrintErrCheckboxChange"
                          class="keynav">
                      </div>
                    </td>
                  </tr>
              </table>
            </el-form>
          </el-row>
        </el-carousel-item>
        <!-- <el-carousel-item>
          <h3 style="font-weight: 100;">Print Payments</h3>
          <el-row
            v-if="building && !checkPdfReady"
            type="flex"
            justify="center"
            align="middle"
            style="padding: 25px 0;">
            <el-progress type="circle" :percentage="buildProgress" />
          </el-row>
          <el-row v-if="!building && checkPdfReady" type="flex" justify="center" align="middle">
            <iframe
              :src="checkPdfReady ? `data:application/pdf;base64,${getCheckrunPdf}` : ''"
              :height="checkPdfHeight"
              width="100%"
              frameborder="0"
            />
          </el-row>
        </el-carousel-item> -->
        <el-carousel-item>
          <el-row style="padding: 12px 0; font-size: 18px;">
            All set
          </el-row>
          <el-row style="font-weight: 500;">
            The following payments have been printed:
          </el-row>
          <el-row>
            <ul>
              <li v-for="p,i in postedChecks" :key="i" style="padding: 6px 0;">
                Payment #{{ p.number }}, paid to <strong>{{ getVendorById(p.vendor).name }}</strong> for {{ getCurrencySymbol(p) }}<strong>{{ p.amount_decimal }}</strong>
              </li>
            </ul>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
    <el-dialog
    title="Report Viewer"
    size="large"
    :show-close="true"
    :close-on-click-modal="true"
    :destroy-on-close="true"
    @close="handleClose"
    @before-close="handleBeforeClose"
    :fullscreen.sync="isFullscreen"
    :visible.sync="pdfLoader"
    :modal="false"
    :style="{ zIndex: 3000 }"
    top="2%">
      <template v-if="loadPdf">
        <el-row type="flex" align="middle" >
          <object :data="`data:application/pdf;base64,${loadPdf}`" type="application/pdf"  width="1500" height="600" ></object>
        </el-row>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { notify } from '@/utils/helpers/Notify'
  import printJS from 'print-js'
  import { payload as checkPayload } from '@/components/RouteComponents/Checks/actionPayload'
  import { payload as paymentPayload } from './actionPayload'
  import { payload as batchPayload } from '@/components/RouteComponents/Batches/actionPayload'
  import MoneyField from '@/components/InputComponents/MoneyField.vue'
  import DateField from '@/components/InputComponents/DateField.vue'

  export default {
    name: 'paymentPrinter',
    components: {
      MoneyField,
      DateField
    },
    props: {
      checksToPrint: Array,
      selectedBank: String || null,
      checkPrinterVisible: Boolean,
      getNumOfChecksToPrintPerBank: Function,
      postedChecks: Array,
      resetParentFields: Function,
      draftChecks: Array,
      paymentType: String,
      startingPaymentConfNumber: String || null
    },
    data () {
      return {
        preview: [],
        error: null,
        dialogVisible: false,
        active: 0,
        startingCheckNumbers: {},
        checks: [],
        checkPreviews: [],
        checkPdfReady: false,
        checkPdfHeight: window.innerHeight - 400,
        checkKey: 0,
        building: false,
        buildProgress: 0,
        printErrors: false,
        enableReprintBtn: false,
        checkRuns: [],
        previewGroups: [],
        paymentConfUpdatedRows: [],
        nextPaymentConfirmationNumber: null,
        fields: [
          {
            name: 'number',
            label: 'Check #'
          },
          {
            name: 'amount_decimal',
            label: 'Amount',
            required: true
          },
          {
            name: 'payee_name',
            label: 'Payee',
            disabled: true,
            required: true
          },
          {
            name: 'bank',
            label: 'Bank',
            disabled: true
          },
          {
            name: 'company',
            label: 'Company',
            required: true
          },
          {
            name: 'description',
            label: 'Memo',
            required: false
          },
          {
            name: 'period',
            label: 'Period',
            required: true
          },
          {
            name: 'pickup',
            label: 'Pickup',
            required: true
          },
          {
            name: 'reprint',
            label: 'Reprint'
          }
        ],
        inclues: { EFT: { include_eft: true }, WIRE: { include_wire_transfers: true }, CHECK_MANUAL: { include_computer_check: true } },
        loadingRelated: false,
        pdfLoader: false,
        paymentInfo: []
      }
    },
    methods: {
      /**
       * Generates a check register report
       */
      async generateCheckRegisterReport () {
        try {
          const endpoint = 'payments/register/'
          const opts = await this.$store.dispatch('fetchFormFields', `/reports/${endpoint}`)
          if (this.checkRuns.length) {
            this.cachingParams = true
            const resp = await this.$store.dispatch('cacheParams', { data: { check_run: this.checkRuns[0].id, ...this.inclues[this.paymentType] || {} } })
            this.cachingParams = false
            if (!resp && resp.id) {
              throw new Error('Unable to cache parameters')
            }
            let { id, reportId } = resp
            const payload = { query: { cached_parameters: id }, type: endpoint, reportId }
            if (opts && opts.template_parameter && opts.templates && Object.keys(opts.templates).length) {
              payload.query[opts.template_parameter] = Object.keys(opts.templates)[0]
            }
            this.$store.dispatch('startRenderingReport', payload)
          }
        } catch (e) {
          console.log(e)
          notify(this, 'warning', `Error generating check register report${e.message ? `: ${e.message}` : ''}`)
        }
      },
      /**
       * Confirmation Dialog box
       * @param title
       * @param message
       * @param type
       * @return {Promise}
       */
      createConfirmationBox (title, message, type) {
        return new Promise((resolve, reject) => {
          if (!message) message = 'Confirm Action?'
          const newEl = this.$createElement
          message = newEl('p', null, [
            newEl('span', null, message + ' '),
            newEl('button',
              {
                attrs: { class: 'dialog-button' },
                on: {
                  click: () => {
                    this.notificationBox.close()
                    return resolve(false)
                  }
                }
              },
              'No' // Button label
            ),
            newEl('button',
              {
                attrs: { class: 'dialog-button button-success' },
                on: {
                  click: () => {
                    this.notificationBox.close()
                    return resolve(true)
                  }
                }
              },
              'Yes' // Button label
            )
          ])
          this.notificationBox = this.$message({
            title: title || 'Message',
            type: type || 'info',
            duration: 0,
            message,
            showClose: true
          })
        })
      },
      /**
       * check duplicate EFT payments
       */
      async checkDuplicatePayments () {
        const paymentConfirmationNumber = this.startingPaymentConfNumber
        let paymentConfirmationNumbers = this.checkPreviews.map((v) => String(v.form.payment_confirmation_number))
        let transactionIds = this.checkPreviews.map((v) => v.form.id)
        let apPayload = {
          payment_confirmation_number__in: [...new Set(paymentConfirmationNumbers)],
          bank_id: this.getBankById(this.selectedBank).id
        }
        if (this.checkPreviews[0].form && this.checkPreviews[0].form.batch) {
          apPayload.batch = this.checkPreviews[0].form.batch.id
        }
        this.$store.dispatch('fetchApsWithQuery', apPayload).then((response) => {
          this.startingPaymentConfNumber = paymentConfirmationNumber
          let duplicatePaymentConfNumbers = []
          if (response.count > 0) {
            Object.values(response.entities.aps).forEach((ap) => {
              if (!transactionIds.includes(ap.id)) {
                let rows = this.checkPreviews.filter((v) => String(v.form.payment_confirmation_number) === String(ap.payment_confirmation_number))
                rows.forEach((row) => {
                  if (!duplicatePaymentConfNumbers.find((v) => v.id === row.form.id)) {
                    duplicatePaymentConfNumbers.push({
                      id: row.form.id,
                      number: row.form.number,
                      payment_confirmation_number: String(row.form.payment_confirmation_number)
                    })
                  }
                })
              }
            })
          }
          return {count: response.count, payments: duplicatePaymentConfNumbers}
        }).then(async (response) => {
          if (response.count > 0 && response.payments.length > 0) {
            const duplicates = [...new Set(response.payments.map((v) => v.payment_confirmation_number))]
            this.createConfirmationBox('Confirm', `Do you want to continue with duplicate payment numbers ${duplicates.join(', ')}`)
              .then(async confirmation => {
                if (confirmation === true) {
                  this.active++
                  if (this.active === 1) {
                    if (this.printErrors) {
                      this.$refs.checkCarousel.next()
                      this.postPrintedChecks()
                      this.createCheckrun({
                        checks: this.paymentType === 'CHECK' ? [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))] : [],                  // TODO: how do we want to handle reprints? Should we create checks anew? Or just another check run?
                        payments: this.paymentType !== 'CHECK' ? [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))] : [],
                        payment_type: this.paymentType
                      })
                    } else {
                      this.$refs.checkCarousel.next()
                      this.buildProgress = 25
                      this.createChecks()
                    }
                  } else if (this.active === 2) {
                    this.postPrintedChecks()
                    this.$refs.checkCarousel.next()
                    this.printErrors = false
                  }
                } else {
                  return false
                }
              })
          } else {
            this.active++
            if (this.active === 1) {
              if (this.printErrors) {
                this.$refs.checkCarousel.next()
                this.postPrintedChecks()
                this.createCheckrun({
                  checks: this.paymentType === 'CHECK' ? [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))] : [],                  // TODO: how do we want to handle reprints? Should we create checks anew? Or just another check run?
                  payments: this.paymentType !== 'CHECK' ? [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))] : [],
                  payment_type: this.paymentType
                })
              } else {
                this.$refs.checkCarousel.next()
                this.buildProgress = 25
                this.createChecks()
              }
            } else if (this.active === 2) {
              this.postPrintedChecks()
              this.$refs.checkCarousel.next()
              this.printErrors = false
            }
          }
        })
      },
      /**
       * Go to next step in CheckPrinter carousel
       */
      async goToNextStep () {
        if (this.active < 3) {
          this.active++
          switch (this.active) {
            case 1:
              this.building = true
              if (this.printErrors) {
                // check duplicate EFT payment numbers
                if (this.paymentType === 'EFT') {
                  this.active--
                  await this.checkDuplicatePayments()
                } else {
                  this.$refs.checkCarousel.next()
                  this.postPrintedChecks()
                  this.createCheckrun({
                    checks: this.paymentType === 'CHECK' ? [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))] : [],                  // TODO: how do we want to handle reprints? Should we create checks anew? Or just another check run?
                    payments: this.paymentType !== 'CHECK' ? [...new Set(this.checks.filter(x => x.printErr).map(v => v.id))] : [],
                    payment_type: this.paymentType
                  })
                }
              } else {
                if (this.verifyCheckForms()) {
                  // check duplicate EFT payment numbers
                  if (this.paymentType === 'EFT') {
                    this.active--
                    await this.checkDuplicatePayments()
                  } else {
                    this.$refs.checkCarousel.next()
                    this.buildProgress = 25
                    this.createChecks()
                  }
                } else {
                  notify(this, 'warning', 'Please fill all required fields')
                  this.active--
                  return
                }
              }
              break
            case 2:
              // check duplicate EFT payment numbers
              if (this.paymentType === 'EFT') {
                this.active--
                await this.checkDuplicatePayments()
              } else {
                this.postPrintedChecks()
                this.$refs.checkCarousel.next()
                this.printErrors = false
              }
          }
        }
      },
      /**
       * Go to previous step in CheckPrinter carousel
       */
      goToPreviousStep () {
        if (this.active > 0) {
          this.active--
          this.$refs.checkCarousel.prev()
        }
      },
      /**
       * Skip to last step in CheckPrinter carousel
       */
      skipToLastStep () {
        this.active = 2
        this.printErrors = false
        this.checks.map(v => {
          v.printErr = false
          return v
        })
        this.$refs.checkCarousel.setActiveItem(2)
        this.postPrintedChecks()
      },
      /**
       * Verify that each check has a value for number and description. If this.checkDateRange is not null, checks for
       * a valid date as well. Returns true if all conditions apply.
       */
      verifyCheckForms () {
        return this.checkPreviews.every(preview => {
          let hasNumberAndDescription = preview.form.payment_confirmation_number && preview.form.description
          // if (!hasNumberAndDescription) { console.log('missing data', preview), 'all', this.checkPreviews }
          return this.checkDateRange ? (hasNumberAndDescription && preview.form.date) : hasNumberAndDescription
        })
      },
      /**
       * Creates batches for checks and checkruns. First, ensures that each check preview has a 'batch' property
       * Then instantiates new instance of the Set class, passing in an array of stringified check preview batches.
       * This creates an array of distinct string representations of batches. Then, we can parse them back to objects
       * and create an array of promises that dispatch a 'save' action for each distinct batch. Once we have this
       * array of promises, we call Promise.all(promises) and save the distinct batches. Finally, we associate each
       * check preview with the correct batch id
       */
      async createBatches () {
        try {
          const distinctBatches = [...new Set(this.checkPreviews
            .filter(preview => !!preview.form.batch)
            .map(preview => JSON.stringify(preview.form.batch))
          )]
          const promises = distinctBatches.map(stringifiedBatch => {
            const data = JSON.parse(stringifiedBatch)
            return this.$store.dispatch('save', { ...batchPayload, data })
          })
          const resp = await Promise.all(promises)
          if (!(resp && resp.length)) {
            throw new Error('Unable to create check run batch')
          }
          this.checkPreviews = this.checkPreviews.map(preview => {
            const correspondingBatchModel = resp.find(batch => {
              const { company, production, bank } = preview.form.batch
              return company === batch.company && production === batch.production && bank === batch.bank
            })
            preview.form.batch = correspondingBatchModel ? correspondingBatchModel.id : null
            return preview
          })
          this.buildProgress = 25
          this.createChecks()
        } catch (e) {
          console.log(e)
          notify(this, 'error', `Error saving checks${e.message ? `: ${e.message}` : ''}`)
        }
      },
      /**
       * Creates checks once APs have been selected
       */
      async createChecks () {  // Create check models from check run quote (preview)
        let aps = this.checkPreviews.map((ap) => { return { id: ap.form.id, payment_date: ap.form.date, payment_confirmation_number: ap.form.payment_confirmation_number || '' } })
        let data = {
          bank: this.checkPreviews[0].form.bank.id,
          production: this.checkPreviews[0].form.production,
          company: this.checkPreviews[0].form.company.value,
          payment_type: this.paymentType,
          aps
        }
        try {
          const resp = await this.$store.dispatch('save', { ...paymentPayload, data })
          if (!(resp && resp.length)) {
            throw new Error('Unable to create checks')
          }
          this.buildProgress = 50
          this.checks = resp.map(check => {
            check['printErr'] = false
            return check
          })
          for (let check of this.draftChecks) {
            check['printErr'] = false
            this.checks.push(check)
          }
          this.createCheckrun({ checks: this.paymentType === 'CHECK' ? [...new Set(resp.map(check => check.id))] : [], payments: this.paymentType !== 'CHECK' ? [...new Set(resp.map(check => check.id))] : [], payment_type: this.paymentType })

          // this.createCheckrun({ checks: [...new Set(resp.map(check => check.id))] })                               // ...create check run
        } catch (e) {
          console.log(e)
          notify(this, 'error', `Error saving checks${e.message ? `: ${e.message}` : ''}`)
        }
      },
      /**
       * POSTs a check run
       * For each check included in this checkrun, sets a 'printErr' property and sets value to false
       * @param checkIds
       */
      async createCheckrun (checkIds) {
        try {
          const resp = await this.$store.dispatch('saveCheckrun', checkIds)
          if (!(resp && resp.id)) {
            throw new Error('Error saving checks: unable to create check run.')
          }
          this.checkRuns.push(resp)
          this.checks = this.checks.map(check => {
            check.printErr = this.paymentType === 'CHECK' ? !checkIds.checks.includes(check.id) : !checkIds.payments.includes(check.id)
            return check
          })
          for (let check of this.draftChecks) {
            check['printErr'] = false
            this.checks.push(check)
          }
          this.buildProgress = 75
          // this.createCheckrunPdf(resp)
          this.buildProgress = 100
          this.building = false
          this.postPrintedChecks()
          this.printErrors = false
        } catch (e) {
          console.log(e)
          notify(this, 'error', e.message)
        }
      },
      /**
       * Generates a check PDF from a given check run
       * @param run   The check run for which to create a PDF
       */
      async createCheckrunPdf (run) {
        try {
          const bank = this.getBankById(this.selectedBank)
          let payload = {}
          if (bank && bank.check_preferred_template) {
            let opts = await this.$store.dispatch('fetchOptions', { endpoint: 'reports/checks' })
            if (opts && opts.template_parameter && this.checks && this.checks[0] && ['EFT', 'WIRE', 'CHECK_MANUAL'].includes(this.paymentType)) {
              if (this.paymentType === 'EFT') {
                payload[opts.template_parameter] = 'payment_receipt_eft'
              } else if (this.paymentType === 'WIRE') {
                payload[opts.template_parameter] = 'payment_receipt_wire_transfer'
              } else if (this.paymentType === 'CHECK_MANUAL') {
                payload[opts.template_parameter] = 'payment_receipt_manual_check'
              }
            } else {
              if (opts && opts.templates && opts.templates[bank.check_preferred_template]) {
                payload[opts.template_parameter] = bank.check_preferred_template
              }
            }
          } else {
            if (this.paymentType === 'EFT') {
              payload.report_template = 'payment_receipt_eft'
            } else if (this.paymentType === 'WIRE') {
              payload.report_template = 'payment_receipt_wire_transfer'
            } else if (this.paymentType === 'CHECK_MANUAL') {
              payload.report_template = 'payment_receipt_manual_check'
            }
          }
          const resp = await this.$store.dispatch('saveCachedParam', { check_run: run.id })
          if (!(resp && resp.id)) {
            throw new Error('Error caching parameters.')
          }
          payload.cached_parameters = resp.id
          const report = await this.$store.dispatch('buildCheckrunPdf', payload)
          this.buildProgress = 100
          this.building = false
          if (report && report.data) {
            this.checkPdfReady = true
            printJS(this.getCheckrunPdfUrl)
          } else {
            throw new Error('Error generating check PDF.')
          }
        } catch (e) {
          console.log(e)
          if (!(e instanceof DOMException)) {
            this.$notify({ title: 'Error', message: e.message || 'Error saving checks', type: 'error' })
          }
        }
      },
      /**
       * POSTs the checks that have been printed
       */
      async postPrintedChecks () {
        try {
          let printedChecks = this.checks.filter(v => !v.printErr)
          if (!printedChecks || !printedChecks.length) return
          let promises = []
          printedChecks.forEach(check => {
            const data = { status: 'POSTED' }
            const payload = this.paymentType === 'CHECK' ? checkPayload : paymentPayload
            let newPayload = Object.assign({}, payload, { data }, { id: check.id })
            promises.push(this.$store.dispatch('update', newPayload))
          })
          const resp = await Promise.all(promises)
          if (!(resp && resp.length)) {
            throw new Error([...new Set(printedChecks.map(v => v.payment_confirmation_number))].toString())
          }
          this.$notify({
            title: 'Success',
            message: `Posted checks ${[...new Set(resp.map(v => v.payment_confirmation_number))].toString()}`,
            type: 'success'
          })
          this.updateCheckArrays(resp)
        } catch (e) {
          console.log(e)
          this.$notify({
            title: 'Error',
            message: `Error posting checks${e.message ? ` ${e.message}` : ''}`,
            type: 'error'
          })
        }
      },
      /**
       * Deletes drafts for checks that failed to print
       * TODO: possibly deprecated
       */
      deleteUnprintedDrafts () {
        let unprintedChecks = this.checks.filter(v => v.printErr)
        if (!unprintedChecks || !unprintedChecks.length) return
        let promises = []
        for (let i = 0; i < unprintedChecks.length; i++) {
          const payload = this.paymentType === 'CHECK' ? checkPayload : paymentPayload
          let newPayload = Object.assign({}, payload, { id: unprintedChecks[i].id })
          promises.push(this.$store.dispatch('delete', newPayload))
        }
        Promise.all(promises)
          .then(r => console.log(`Deleted checks ${r.toString}`))
          .catch(e => console.log(e))
      },
      /**
       * Add posted checks to this.postedChecks and remove from this.checks
       * @param checks
       */
      updateCheckArrays (checks) {
        const findIndex = (checkId) => {
          for (let j = 0; j < this.checks.length; j++) {
            if (this.checks[j].id === checkId) return j
          }
          return false
        }
        for (let i = 0; i < checks.length; i++) {
          const index = findIndex(checks[i].id)
          if (index) this.checks.splice(index, 1)
          if (this.postedChecks.find(v => v.id === checks[i].id)) continue
          this.postedChecks.push(checks[i])
          this.$emit('updatePostedChecks', this.postedChecks)
        }
      },
      /**
       * Create a check form for a given AP
       * @param check
       */
      addCheck (check) {
        this.checkKey++
        this.checkPreviews.push({
          check: `check_${this.checkKey}`,
          form: this.buildCheckForm(check)
        })
      },
      updatePreview (inputArray) {
        this.previewGroups = []
        return inputArray.reduce((accumulator, currentObj) => {
          const existingIndex = accumulator.findIndex(
            (item) =>
              item.form.payment_confirmation_number === currentObj.form.payment_confirmation_number &&
              item.form.vendor === currentObj.form.vendor &&
              item.form.company.label === currentObj.form.company.label &&
              item.form.company.value === currentObj.form.company.value
          )
          if (existingIndex !== -1) {
            // If the entry already exists, update the amount_decimal
            accumulator[existingIndex].form.amount_decimal += currentObj.form.amount_decimal
            this.previewGroups.push(currentObj)
          } else {
            // If the entry doesn't exist, add a new entry
            accumulator.push({ ...currentObj })
          }
          return accumulator
        }, [])
      },
      updateGroupedCheckPreviews (preview) {
        if (!['CHECK', 'EFT'].includes(this.paymentType) && this.previewGroups.length) {
          this.checkPreviews.filter(
            (item) =>
              item.form.vendor === preview.form.vendor &&
              item.form.company.label === preview.form.company.label &&
              item.form.company.value === preview.form.company.value
          ).map((checkPreview) => {
            if (this.previewGroups.find(x => x.form.id === checkPreview.form.id)) {
              checkPreview.form.payment_confirmation_number = preview.form.payment_confirmation_number
            }
          })
        }
      },
      /**
       * Build the check form, with data from the check quotes
       * @param check
       * @return {Object}
       */
      buildCheckForm (check) {
        return {
          account_cash: check.account_cash.id || '',
          account_clearing: check.account_clearing.id || '',
          amount_decimal: check.amount_decimal || '',
          bank: this.getBankById(check.batch.bank) || '',
          batch: check.batch || '',
          company: {
            label: this.getCompanyById(check.batch.company).name || '',
            value: this.getCompanyById(check.batch.company).id || ''
          },
          date: check.payment_date,
          description: check.description,
          id: check.id,
          payment_confirmation_number: check.payment_confirmation_number || '',
          payee_name: check.payee_name || '',
          payee_address: check.payee_address || '',
          period: check.period || this.currentPeriod.id || null,
          pickup: check.pickup || false,
          production: check.batch.production,
          status: 'DRAFT',
          vendor: check.vendor.id || '',
          related_transactions: (check.related_transactions && check.related_transactions.length)
            ? [...new Set(check.related_transactions.map(v => v.id))]
            : [],
          reprint: false
        }
      },
      /**
       * Sets the starting check numbers
       */
      setStartingCheckNumbers () {
        const bankCheckNums = this.getCheckNumbers[this.selectedBank]
        if (bankCheckNums && Array.isArray(bankCheckNums) && bankCheckNums.length) {
          this.startingCheckNumbers[this.selectedBank] = bankCheckNums[0]
        }
      },
      /**
       * Assigns payment number to each check
       */
      assignPaymentConfirmationNumbers () {
        let next = (this.nextPaymentConfirmationNumber !== null)
        let nextPaymentConfirmationNumber = this.nextPaymentConfirmationNumber ? this.nextPaymentConfirmationNumber : this.startingPaymentConfNumber
        let paymentConfirmationNumber = ''
        this.checkPreviews.map((checkPreview) => {
          if (!checkPreview.form.payment_confirmation_number) {
            const paymentVendor = this.paymentConfUpdatedRows.find((v) => v.vendor === checkPreview.form.vendor)
            if (paymentVendor) {
              paymentConfirmationNumber = paymentVendor.payment_confirmation_number
              this.paymentConfUpdatedRows.push({
                id: checkPreview.form.id,
                vendor: checkPreview.form.vendor,
                payment_confirmation_number: paymentConfirmationNumber
              })
              checkPreview.form.payment_confirmation_number = paymentConfirmationNumber
            } else {
              paymentConfirmationNumber = this.getNextPaymentNumber(nextPaymentConfirmationNumber, next)
              nextPaymentConfirmationNumber = paymentConfirmationNumber
              next = true

              if (this.checkPreviews.filter((p) => String(p.form.payment_confirmation_number) === String(paymentConfirmationNumber)).length) {
                this.nextPaymentConfirmationNumber = paymentConfirmationNumber
                this.assignPaymentConfirmationNumbers()
              } else {
                this.paymentConfUpdatedRows.push({
                  id: checkPreview.form.id,
                  vendor: checkPreview.form.vendor,
                  payment_confirmation_number: paymentConfirmationNumber
                })
                checkPreview.form.payment_confirmation_number = paymentConfirmationNumber
              }
            }
          }
        })
      },
      getNextPaymentNumber (paymentConfirmationNumber, next) {
        if (next) {
          let numericPart = parseInt(paymentConfirmationNumber.match(/\d+/g))
          let nextPaymentNumber = numericPart + 1
          let reg = new RegExp(numericPart)
          return paymentConfirmationNumber.replace(reg, nextPaymentNumber)
        } else {
          return paymentConfirmationNumber
        }
      },
      updatePaymentConfNumbersOnStep2 () {
        this.nextPaymentConfirmationNumber = null
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.processPaymentConfNumbersOnStep2([])
        }, 1000)
      },
      processPaymentConfNumbersOnStep2 (paymentConfirmationUpdatedRows) {
        let next = (this.nextPaymentConfirmationNumber !== null)
        let nextPaymentConfirmationNumber = this.nextPaymentConfirmationNumber ? this.nextPaymentConfirmationNumber : this.startingPaymentConfNumber
        let paymentConfirmationNumber = ''

        this.checkPreviews.map((checkPreview, i) => {
          if (this.paymentConfUpdatedRows.find((v) => v.id === checkPreview.form.id)) {
            const paymentVendor = paymentConfirmationUpdatedRows.find((v) => v.vendor === checkPreview.form.vendor)
            if (paymentVendor) {
              paymentConfirmationNumber = paymentVendor.payment_confirmation_number
              paymentConfirmationUpdatedRows.push({
                id: checkPreview.form.id,
                vendor: checkPreview.form.vendor,
                payment_confirmation_number: paymentConfirmationNumber
              })
              checkPreview.form.payment_confirmation_number = paymentConfirmationNumber
            } else {
              paymentConfirmationNumber = this.getNextPaymentNumber(nextPaymentConfirmationNumber, next)
              nextPaymentConfirmationNumber = paymentConfirmationNumber
              next = true

              if (this.checkPreviews.filter((p) => String(p.form.payment_confirmation_number) === String(paymentConfirmationNumber)).length) {
                this.nextPaymentConfirmationNumber = paymentConfirmationNumber
                this.processPaymentConfNumbersOnStep2(paymentConfirmationUpdatedRows)
              } else {
                paymentConfirmationUpdatedRows.push({
                  id: checkPreview.form.id,
                  vendor: checkPreview.form.vendor,
                  payment_confirmation_number: paymentConfirmationNumber
                })
                checkPreview.form.payment_confirmation_number = paymentConfirmationNumber
              }
            }
          }
          if (this.checkPreviews.length === (i) + 1) {
            this.paymentConfUpdatedRows = paymentConfirmationUpdatedRows
          }
        })
      },
      /**
       * Assigns check number to each check
       */
      assignCheckNumbers () {
        let assigned = {}
        this.checkPreviews.map((v, k) => {
          const checkNums = this.getCheckNumbers[v.form.bank.id]
          if (!(checkNums && Array.isArray(checkNums) && checkNums.length)) {
            return v
          }
          const bank = v.form.bank.id
          if (!assigned[bank]) {
            assigned[bank] = 0
          }
          if (checkNums[assigned[bank]]) {
            v.form.number = checkNums[assigned[bank]]
            if (checkNums.length - 1 > assigned[bank]) {
              assigned[bank] = assigned[bank] += 1
            }
          } else {
            v.form.number = ''
          }
          return v
        })
      },
      /**
       * Reprint checks
       */
      reprintChecks () {
        this.enableReprintBtn = false
        this.buildProgress = 0
        this.checkPdfReady = false
        this.printErrors = true
        this.goToPreviousStep()
      },
      /**
       * Update check numbers
       */
      updateCheckNumbers () {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(async () => {
          const id = this.selectedBank
          try {
            await this.$store.dispatch('fetchCheckNumbers', {
              id,
              params: { amount: this.getNumOfChecksToPrintPerBank()[id], range_start: this.startingCheckNumbers[id] }
            })
            this.assignCheckNumbers()
          } catch (e) {
            console.log(e)
            this.$notify({ title: 'Error', message: 'Error re-numbering checks', type: 'error' })
          }
        }, 1000)
      },
      handlePrintErrCheckboxChange () {
        let printErrs = this.checks.filter(v => v.printErr)
        this.enableReprintBtn = !!(printErrs && printErrs.length)
      },
      /**
       * Reset data properties, used when the modal is closed
       */
      resetFields () {
        this.error = null
        this.active = 0
        this.startingCheckNumbers = {}
        this.checks = []
        this.checkPreviews = []
        this.checkPdfReady = false
        this.building = false
        this.buildProgress = 0
        this.checkKey = 0
        this.printErrors = false
        this.enableReprintBtn = false
        this.checkRuns = []
        this.paymentConfUpdatedRows = []
        this.nextPaymentConfirmationNumber = null
        this.$emit('updatePostedChecks', [])                                                                // Update list of posted checks on parent component
        this.$emit('resetParentFields')                                                                     // Resets relevant fields on the parent component
      },
      /**
       * Close the modal dialog box, reset fields on this component and on the parent
       */
      closeCheckPrinter () {
        this.dialogVisible = false
        this.$refs.checkCarousel.setActiveItem(0)
        this.resetFields()
      },
      getCurrencySymbol (data) {
        return data.currency_data ? data.currency_data.symbol : '$'
      },
      async printCopyMethod () {
        this.loadingRelated = true
        // Get the selected payment info from Vuex store
        this.paymentInfo = this.$store.state.payment.selection
        // Arrays to store IDs based on payment type
        let paymentIn = []
        let accountPayableIn = []
        let checksIn = []
        // Loop through the paymentInfo array to categorize payment types
        this.paymentInfo.forEach((ap) => {
          if (ap.payment_type !== 'CHECK') {
            paymentIn.push(ap.id)
            accountPayableIn.push(ap.id)
          } else {
            checksIn.push(ap.id)
          }
        })
        // Construct the payload to pass to the API
        const newPayload = {
          payment__in: paymentIn,
          checks__in: checksIn,
          accountpayable__in: accountPayableIn
        }
        // Dispatch an action to cache the parameters
        const resp1 = await this.$store.dispatch('cacheParams', { data: newPayload })
        // Call the function to create the PDF
        this.createCheckrunPdfsecond(resp1)
      },
      async createCheckrunPdfsecond (resp) {
        try {
          const bank = this.getBankById(this.selectedBank.id)
          let payload = {}
          // Check if there is payment info and if the bank has a check-preferred template
          if (bank && bank.check_preferred_template) {
            let opts = await this.$store.dispatch('fetchOptions', { endpoint: 'reports/checks' })
            if (opts && opts.template_parameter && this.paymentInfo.length > 0) {
              // Get the payment type of the first item in the paymentInfo array
              const paymentType = this.paymentInfo[0].payment_type
              // Determine the template based on the payment type
              if (['EFT', 'WIRE', 'CHECK', 'CHECK_MANUAL'].includes(paymentType)) {
                payload[opts.template_parameter] = this.getReportTemplate(paymentType)
              } else if (opts.templates && opts.templates[bank.check_preferred_template]) {
                payload[opts.template_parameter] = bank.check_preferred_template
              }
            }
          } else {
            // If no bank info, fallback to the first payment type
            const paymentType = this.paymentInfo[0].payment_type
            payload.report_template = this.getReportTemplate(paymentType)
          }
          payload.cached_parameters = resp.id
          // Generate the PDF
          const report = await this.$store.dispatch('buildPrintCopyrunPdf', payload)
          this.buildProgress = 100
          this.loadingRelated = false
          // Set the PDF data to be displayed
          setTimeout(() => {
            this.loadPdf = report.data // Set the new PDF data
            this.pdfLoader = true // Open the dialog
          }, 100)
        } catch (e) {
          console.error(e)
          this.loadingRelated = false
          if (!(e instanceof DOMException)) {
            this.$notify({
              title: 'Error',
              message: e.message || 'Error generating PDF',
              type: 'error'
            })
          }
        }
      },
      getReportTemplate (paymentType) {
        // Determine the appropriate template for each payment type
        const templates = {
          EFT: 'payment_receipt_eft',
          WIRE: 'payment_receipt_wire_transfer',
          CHECK: 'default',
          CHECK_MANUAL: 'payment_receipt_manual_check'
        }
        return templates[paymentType] || 'default'
      }
    },
    computed: {
      ...mapGetters({
        getCompanyById: 'getCompanyById',
        getCompanyByBatchId: 'getCompanyByBatchId',
        getBankById: 'getBankById',
        getBankByCompanyId: 'getBankByCompanyId',
        getBankByBatchId: 'getBankByBatchId',
        currentPeriod: 'getCurrentPeriod',
        getPeriodById: 'getPeriodById',
        getVendorById: 'getVendorById',
        getCheckNumbers: 'getCheckNumbers',
        getCheckrunPdf: 'getCheckrunPdf',
        getCheckrunPdfUrl: 'getCheckrunPdfUrl',
        getCachedParamById: 'getCachedParamById',
        getReportFetchStatus: 'getReportFetchStatus'
      }),
      /**
       * Computed property that returns the available options for the period dropdown field
       */
      periodOptions () {
        const options = [{ label: 'Next', value: null }]
        if (this.currentPeriod && this.currentPeriod.id) {
          options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        return options
      },
      /**
       * Computed property that returns a boolean indicating whether a report is currently being processed
       * @return boolean
       */
      processingReport () {
        return !!(this.getReportFetchStatus && this.getReportFetchStatus.status || this.cachingParams)
      },
      /**
       * Computed property that returns the allowable check date range, if any.
       */
      checkDateRange () {
        const { getUiSettings } = this.$store.getters
        const defaultRange = { start: -14, end: 14 }
        try {
          if (getUiSettings['CHECK_DATE_RANGE']) {
            const range = JSON.parse(getUiSettings['CHECK_DATE_RANGE'])
            if (range && typeof range.start === 'number' && typeof range.end === 'number' && range.start < range.end) {
              return { start: range.start, end: range.end }
            } else {
              throw new RangeError()
            }
          } else {
            throw new Error()
          }
        } catch (e) {
          let msg = 'No CHECK_DATE_RANGE setting specified. Falling back to default range of 14 days pre-dated ' +
            'and 14 days post-dated.'
          if (e instanceof RangeError) {
            msg = 'Invalid CHECK_DATE_RANGE parameter values. Setting must specify integer values ' +
              "for 'start' (optional) and 'end', where 'start' must be less than 'end', representing the start and " +
              'end of a date range as the number of days relative to the current date. Falling back to default range ' +
              'of 14 days pre-dated and 14 days post-dated (start: -14, end: 14).'
          }
          console.warn(msg)
          return defaultRange
        }
      },
      /**
       * Returns the string representation of the date range for which a check date must be between.
       */
      allowableDateRangeString () {
        const nDaysAgo = new Date(Date.now())
        const nDaysFromNow = new Date(Date.now())
        nDaysAgo.setDate(nDaysAgo.getDate() + this.checkDateRange.start)
        nDaysFromNow.setDate(nDaysFromNow.getDate() + this.checkDateRange.end)
        return `${new Date(nDaysAgo).toLocaleDateString()} - ${new Date(nDaysFromNow).toLocaleDateString()}`
      },
      /**
       * Returns the default check date, depending on the start and end values of this.checkDateRange.
       */
      defaultCheckDate () {
        const { start, end } = this.checkDateRange
        const startDate = new Date(Date.now())
        if (start < 0 && end > 0) {
          startDate.toLocaleDateString()
        } else if (start < 0 && end === 0) {
          startDate.setDate(startDate.getDate() + end)
        } else {
          startDate.setDate(startDate.getDate() + start)
        }
        return new Date(startDate).toLocaleDateString()
      }
    },
    watch: {
      /**
       * Build form on prop change
       */
      checksToPrint () {
        if (this.checksToPrint && this.checksToPrint.length) { // Build data element containing first avail check numbers
          this.checksToPrint.forEach(check => this.addCheck(check))
          this.preview = this.updatePreview(this.checkPreviews)
        }
      },
      draftChecks () {
        if (this.draftChecks && this.draftChecks.length) { // Build data element containing first avail check numbers
          this.draftChecks.forEach(check => this.addCheck(check))
          this.preview = this.updatePreview(this.checkPreviews)
        }
      },
      /**
       * Shows or hides the CheckPrinter component
       */
      checkPrinterVisible () {
        this.dialogVisible = this.checkPrinterVisible
      },
      getCheckNumbers () {
        this.setStartingCheckNumbers()
        const numberOfCheckNums = Object.values(this.getCheckNumbers).map(v => v.length).reduce((a, b) => a + b, 0)
        if (this.checksToPrint && (numberOfCheckNums === this.checksToPrint.length)) {
          this.assignCheckNumbers()
        }
        if (this.paymentType === 'EFT') {
          this.nextPaymentConfirmationNumber = null
          this.paymentConfUpdatedRows = []
          this.assignPaymentConfirmationNumbers()
        }
      }
    }
  }
</script>

<style>
  td input {
    border: none !important;
    height: 22px !important;
    text-align: left;
  }
  .el-input {
    font-size: 12px;
  }
  .el-select .el-input__inner {
    padding-right: 0;
  }
</style>

<style scoped>
  .check-amt-field {
    text-align: right !important;
  }
  .check-form-label {
    padding: 10px 0;
  }
  .check-form-field {
    padding: 10px 0;
  }
  /*Table style properties*/
  table {
    width: 100%;
    margin-bottom: 1em;
    border-collapse: collapse;
  }
  td {
    padding: 0.2em;
    border: 1px solid #ccc;
  }
  .cell-gray {
    background: #eaeaea;
  }
  .cell-padded {
    padding: 6px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Programs/PaymentProcessing/PaymentPrinter.vue